import { render } from "./TrashIcon.vue?vue&type=template&id=fc3e9390&scoped=true"
const script = {}

import "./TrashIcon.vue?vue&type=style&index=0&id=fc3e9390&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3e9390"]])

export default __exports__